/**==============================================
 *     CONTEXTO DEL ESTADO GLOBAL
 *   
 *  @descripcion: Declaracion y configuracion del estado global donde se guardan los store 
 * 
 *=============================================**/
import React, {createContext, useRef, useContext} from 'react';
import { createStore, useStore } from 'zustand';


// Merge de objeto configuración
const mergeObject = (store, c) => {   
    return {...store,...c};
}

export const StoreContexto = createContext();

// Contexto del Store global
const useStoreGlobal = (selector) => {
    const store = useContext(StoreContexto)
    if (!store) {
        throw new Error('Missing StoreProvider')
    }
    return useStore(store, selector)
}
// Provider
const StoreProvider = ({children}) => {
    let store = useRef()
    if(!store.current){
        store.current = createStore((set, get) => ({ 
            _filtros:{
                camposBuscador: "cbusqueda",
                camposOrden: 'ranking',
                coleccion : "Todo",
                ordenamiento:"desc",
                paginaInicial:0,
                paginaFin:10,
                metodoBusqueda:1,
                textoBusqueda: ""
                
            }, // store parámetros de configuracion de entrada
            // Actualiza de las opciones de la gráfica
            _updateFiltros:(p) => {
                let oOpciones = get()._filtros;                               
                let aMerged = mergeObject(oOpciones,p);
                set((state) =>({_filtros:aMerged}))
            },
            _totalBusqueda:{
                totalDatos:0
            }, // store parámetros de configuracion de entrada
            // Actualiza de las opciones de la gráfica
            _updateTotalDatos:(p) => {
                let oOpciones = get()._totalBusqueda;                               
                let aMerged = mergeObject(oOpciones,p);
                set((state) =>({_totalBusqueda:aMerged}))
            },
            _totalBotonClic:{
                // botonConsulta:0
            }, // store parámetros de configuracion de entrada
            // Actualiza de las opciones de la gráfica
            _updateBotonClic:(p) => {
                let oOpciones = get()._totalBotonClic;                               
                let aMerged = mergeObject(oOpciones,p);
                set((state) =>({_totalBotonClic:aMerged}))
            },
            _totalAreaGeo:{
                valorAreaFinal: ""
                // botonConsulta:0
            }, // store parámetros de configuracion de entrada
            // Actualiza de las opciones de la gráfica
            _updateAreasGeo:(p) => {
                let oOpciones = get()._totalAreaGeo;                               
                let aMerged = mergeObject(oOpciones,p);
                set((state) =>({_totalAreaGeo:aMerged}))
            },
            _totalPage:{
                // botonConsulta:0
            }, // store parámetros de configuracion de entrada
            // Actualiza de las opciones de la gráfica
            _updatePage:(p) => {
                let oOpciones = get()._totalPage;                               
                let aMerged = mergeObject(oOpciones,p);
                set((state) =>({_totalPage:aMerged}))
            },
            _radioBie:{
                textoBusqueda: ""
            }, // store parámetros de configuracion de entrada
            // Actualiza de las opciones de la gráfica
            _updateradioBie:(p) => {
                let oOpciones = get()._radioBie;                               
                let aMerged = mergeObject(oOpciones,p);
                set((state) =>({_radioBie:aMerged}))
            },
        }))
    }
    return (
        <StoreContexto.Provider value={store.current}> 
            {children}
        </StoreContexto.Provider>  
    )
} 
export {
    useStoreGlobal,
    StoreProvider
}